<template>
  <div>
    <div class="flex flex-col justify-start" v-if="hasNotifications">
      <div class="fixed border-b border-gray-200 w-full px-3 bg-white z-30"
        role="group">
        <button
          @click="setNotificationsFilter('all')"
          :class="notificationsFilter === 'all' ?
          'border-orange-academy-300 text-orange-academy-300 whitespace-nowrap border-b-2' :
          'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2'"
          class="text-sm lg:text-base tracking-wider text-left p-3 uppercase font-light pl-4"
        >
          {{$t('messages.all')}}
        </button>
        <button
          @click="setNotificationsFilter('toRead')"
          :class="notificationsFilter === 'toRead' ?
          'border-orange-academy-300 text-orange-academy-300 whitespace-nowrap border-b-2' :
          'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2'"
          class="text-sm lg:text-base tracking-wider text-left p-3 uppercase font-light"
        >
          {{$t('messages.toread')}}
        </button>
      </div>
      <div class="mt-14">
        <notification-container-small
          v-for="notification in notificationsFiltered"
          :key="notification.id"
          :notification="notification"
        ></notification-container-small>
      </div>
    </div>
    <div v-else class="text-sm ml-6 mt-10">
      {{$t('notifications.noNotifications')}}
    </div>
<!--     <div class="mt-14">
      <notification-container-small
        v-for="notification in notificationsFiltered"
        :key="notification.id"
        :notification="notification"
      ></notification-container-small>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NotificationContainerSmall from './notifications/NotificationContainerSmall.vue';

export default {
  components: { NotificationContainerSmall },
  data() {
    return {
      notificationsFilter: 'all',
    };
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('notifications', ['hasNotifications', 'notifications']),
    notificationsByUserType() {
      // the regex match the string after the last backslash. In this case the UserType
      return this.notifications
        .filter(
          (notification) => notification.notifiable_type.match(/[^/\\]+$/)[0].toLowerCase() === this.user.user_type
            || notification.notifiable_type.match(/[^/\\]+$/)[0] === 'User',
        )
        .sort((firstItem, secondItem) => secondItem.updated_at - firstItem.updated_at);
    },
    notificationsFiltered() {
      switch (this.notificationsFilter) {
        case 'toRead':
          return this.notificationsByUserType.filter((notification) => !notification.read_at);
        default:
          return this.notificationsByUserType;
      }
    },
  },
  methods: {
    setNotificationsFilter(filter) {
      this.notificationsFilter = filter;
    },
  },
};
/* import { mapGetters } from 'vuex';
import axios from 'axios';
// import AcceptNewLessonTime from '@/components/modals/AcceptNewLessonTime.vue';
// import StudentRejectsLesson from '@/components/modals/StudentRejectsLesson.vue';
import store from '../store';

export default {
  data() {
    return {
      selectedNotification: {},
      componentToOpen: '',
    };
  },

  computed: {
    ...mapGetters({
      notifications: 'auth/notifications',
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
      dashboardPath: 'auth/dashboardPath',
    }),

    // notificationsToRead() {
    //   return this.notifications.filter((notification) => notification.read === 0);
    // },

    iconColor() {
      if (this.user && this.isTeacher) {
        return 'hover:text-white';
      }
      return 'hover:text-chocolate-academy-600';
    },

    numberColor() {
      if (this.user && this.isTeacher) {
        return 'bg-white text-purple-500';
      }
      return 'bg-beige-academy-300 text-white';
    },
  },

  methods: {
    classType(read) {
      if (read === 0) return 'bg-beige-academy-200';
      return 'bg-white';
    },

    notificationClass(notification) {
      let classe = this.isTeacher ? 'border-grey-academy-200'
        : 'border-grey-academy-200';
      if (!notification.read) {
        classe += ' bg-orange-academy-300 border border-white text-white hover:bg-opacity-75';
      } else {
        classe += 'hover:bg-gray-100';
      }
      return classe;
    },

    setOverflow() {
      if (this.notifications.length > 7) return 'overflow-auto h-1/2';
      return '';
    },

    printDate(date) {
      const newDate = new Date(date);
      const hours = (newDate.getHours() < 10 ? '0' : '') + newDate.getHours();
      const minutes = (newDate.getMinutes() < 10 ? '0' : '') + newDate.getMinutes();
      return `${hours}:${minutes} ${newDate.getDay()}/${newDate.getMonth()}
      /${newDate.getFullYear()}`;
    },

    readNotification(notification) {
      this.selectedNotification = notification;
      this.$emit('open', notification);
      axios.put(`/api/notifications/${notification.id}/read`).then(() => {
        store.dispatch('notifications/getNotifications');
      }).catch((errors) => {
        console.log(errors);
      });
    },

    closeNotifications() {
      this.seeNotifications = false;
    },
  },
}; */

</script>
